import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlusIconSvg } from '@g99-product-web-ui/shared-util-lib';

@Component({
  selector: 'lib-table-no-result',
  templateUrl: './table-no-result.component.html',
  styleUrl: './table-no-result.component.scss',
  standalone: false,
})
export class TableNoResultComponent {
  @Input() public title = 'No results found';
  @Input() public subtext = 'There are no results found for your request';
  @Input() public showButton = false;
  @Input() public buttonLabel = '';

  @Output() public buttonClick = new EventEmitter<void>();

  public svgIcon = PlusIconSvg;

  public onButtonClick() {
    this.buttonClick.emit();
  }
}
